import React, { Suspense } from "react";
import { Route, Routes, Navigate, BrowserRouter } from "react-router-dom";
import Layout from "layouts";
import { AxiosInterceptor } from 'helpers/api';

const Homepage = React.lazy(() => import(/* webpackChunkName: "views-home" */ "views/home"));
const Access = React.lazy(() => import(/* webpackChunkName: "views-delivery-access" */ "views/delivery/access"));
const Select = React.lazy(() => import(/* webpackChunkName: "views-delivery-create" */ "views/delivery/select"));
const Deposit = React.lazy(() => import(/* webpackChunkName: "views-delivery-deposit" */ "views/delivery/deposit"));
const Success = React.lazy(() => import(/* webpackChunkName: "views-delivery-success" */ "views/delivery/success"));
const NotFoundPage = React.lazy(() => import(/* webpackChunkName: "views-404" */ "views/404"));

const Router = () => {

  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <AxiosInterceptor>
          <Layout>
            <Routes>
              <Route index element={<Navigate to="/home" />} />
              <Route exact path="/home" element={<Homepage />} />
              <Route exact path="/access" element={<Access />} />
              <Route exact path="/select" element={<Select />} />
              <Route exact path="/deposit" element={<Deposit />} />
              <Route exact path="/success" element={<Success />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </AxiosInterceptor>
      </BrowserRouter>
    </Suspense >
  );
};

export default Router;
